// uuid → número de consulta (9 dígitos) + dígito verificador Luhn
export function uuidToConsulta9(uuid) {
  // Validar que uuid existe y es una cadena
  if (!uuid || typeof uuid !== 'string') {
    throw new Error('UUID inválido: debe ser una cadena no vacía');
  }

  const hex = uuid.replace(/-/g, '').toLowerCase();
  if (hex.length !== 32) throw new Error('UUID inválido: debe tener 32 caracteres hexadecimales');

  // Mezcla los 128 bits y reduce a 9 dígitos (mod 1e9)
  // Usamos una mejor estrategia de hash para distribuir mejor los números
  let hash = 0;
  for (let i = 0; i < hex.length; i++) {
    const char = hex.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convertir a 32-bit integer
  }
  
  // Asegurar que sea positivo y convertir a 9 dígitos
  const positiveHash = Math.abs(hash);
  const base = (positiveHash % 1000000000).toString().padStart(9, '0');

  const dv = luhnDigit(base);
  // Formato amigable: 3-3-3-DV
  return `${base.slice(0,3)}-${base.slice(3,6)}-${base.slice(6)}-${dv}`;
}

function luhnDigit(num) {
  let sum = 0, alt = true;
  for (let i = num.length - 1; i >= 0; i--) {
    let n = num.charCodeAt(i) - 48;
    if (alt) { n *= 2; if (n > 9) n -= 9; }
    sum += n; alt = !alt;
  }
  return (10 - (sum % 10)) % 10;
}
